<template>
  <div :class="['booking-timer', { warning: reservedTimeLeft <= 300 }]">
    <div v-if="reservedTimeLeft > 0">
      {{ $t("pages.new_booking.booking_timer_alive", { reservedMinutes, reservedSeconds }) }}
    </div>
    <div v-else>
      {{ $t("pages.new_booking.booking_timer_expired") }}
    </div>
  </div>
</template>

<script>
import { BOOKING_RESERVE_EXPIRY_SECONDS } from "@base/configs";

export default {
  name: 'BookingTimer',

  props: {
    bookingsInfo: {
      type: Array,
      required: true
    },
    expirationSeconds: {
      type: Number,
      default: BOOKING_RESERVE_EXPIRY_SECONDS
    }
  },

  data () {
    return {
      currentTime: new Date(),
      intervalId: null
    };
  },

  computed: {
    earliestReservedBooking() {
      if (!this.bookingsInfo || this.bookingsInfo.length === 0) return null;
      return this.bookingsInfo.reduce((r, o) => o.reservedAt < r.reservedAt ? o : r).reservedAt;
    },

    reservedTimeLeft() {
      if (!this.earliestReservedBooking) return 0;

      const reservedAt = new Date(this.earliestReservedBooking);
      const secondsPassed = Math.floor((this.currentTime - reservedAt) / 1000);
      const remaining = this.expirationSeconds - secondsPassed;
      return Math.max(remaining, 0);
    },

    reservedMinutes() {
      return String(Math.floor(this.reservedTimeLeft / 60)).padStart(2, '0');
    },

    reservedSeconds() {
      return String(this.reservedTimeLeft % 60).padStart(2, '0');
    }
  },

  created () {
    this.intervalId = setInterval(() => {
      this.currentTime = new Date();
      if (this.reservedTimeLeft <= 0) {
        clearInterval(this.intervalId);
        this.$emit('expired');
      }
    }, 1000);
  },

  beforeDestroy () {
    clearInterval(this.intervalId);
  }
};
</script>

<style scoped>
.booking-timer {
  font-weight: bold;
  font-size: 16px;
  color: #2c3e50;
}
.booking-timer.warning {
  color: red;
}
</style>